/*
 * Cart gift guard (Marlow & Grace) — the free "Compression Socks — Free Gift" (£0)
 * is only valid with a 2+ pair bundle. Removes the free-gift line if the cart
 * has fewer than 2 sneaker units, and caps it at 1 per order. Runs on load and
 * after every cart:update (debounced 500ms to avoid mid-bundle race conditions
 * while the bundle widget is still adding the pairs). Delegated + idempotent so
 * it survives Horizon cart morphs.
 */
(function () {
  if (window.__orthoshiftGiftGuardBound) return;
  window.__orthoshiftGiftGuardBound = true;

  var GIFT_HANDLE = 'compression-socks-free-gift';
  var SNEAKER_PREFIX = 'orthoshift-all-day-comfort-sneaker';
  var MIN_PAIRS = 2;
  var running = false;
  var timer = null;

  async function enforce() {
    if (running) return;
    running = true;
    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var items = cart.items || [];
      var giftLines = items.filter(function (i) { return i.handle === GIFT_HANDLE; });
      if (!giftLines.length) return;

      var sneakerUnits = items.reduce(function (s, i) {
        return (i.handle && i.handle.indexOf(SNEAKER_PREFIX) === 0) ? s + i.quantity : s;
      }, 0);

      var updates = {};
      var changed = false;
      if (sneakerUnits < MIN_PAIRS) {
        // Not enough pairs -> remove every free-gift line.
        giftLines.forEach(function (g) { updates[g.key] = 0; changed = true; });
      } else {
        // Qualifies -> keep exactly one free pair of socks.
        var kept = false;
        giftLines.forEach(function (g) {
          if (!kept) {
            if (g.quantity !== 1) { updates[g.key] = 1; changed = true; }
            kept = true;
          } else {
            updates[g.key] = 0; changed = true;
          }
        });
      }
      if (!changed) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      document.dispatchEvent(
        new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'gift-guard' } } })
      );
    } catch (e) {
      /* fail silent — never block the cart */
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 500);
  }

  document.addEventListener('cart:update', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
